<template>
  <a-table
    class="detail-table"
    :class="{ 'dark-theme-table': darkTheme }"
    rowKey="numero"
    :pagination="false"
    :scroll="{ y: true }"
    :columns="columns"
    :dataSource="this.detailsData"
    :expandIconColumnIndex="3"
    :expandIconAsCell="false"
    :locale="{ emptyText: 'Rien à afficher' }"
    :customRow="(record) => {
      return {
        on: {
          click: () => {
            handleRowClick(record)
          }
        }
      }
    }"
    :rowClassName="getRowClassName" >
    <template slot="icon" slot-scope="text, record">
      <div numero="icon">
        <template v-if="record.loginValidateur">
          <a-tooltip placement="top" >
            <template slot="title">
              <span>Validé par <b>{{ record.loginValidateur }}</b> le {{ record.dateValidation }} à {{ record.heureValidation }}</span>
            </template>
            <a-icon type="check-circle" class="font-size-20" />
          </a-tooltip>
        </template>
        <template v-else-if="record.loginCorrecteur">
          <a-tooltip placement="top" >
            <template slot="title">
              <span>Demande de correction par <b>{{ record.loginCorrecteur }}</b> le {{ record.dateRemediation }} à {{ record.heureRemediation }}</span>
            </template>
            <a-icon type="exclamation-circle" class="font-size-20" />
          </a-tooltip>
        </template>
      </div>
    </template>
    <template slot="dateDetail" slot-scope="text, record">
      <div numero="dateDetail">
        <a-date-picker
          v-if="record.numero === ongoingAlteredRow.numero && ongoingAlteredRow.editable"
          :defaultValue="moment(text, dateFormat)"
          :format="dateFormat"
          @change="(date, dateString) => handleChangeDetailField(dateString, record.numero, 'dateDetail')" />
        <template v-else><div class="font-size-17">{{ text }}</div></template>
      </div>
    </template>
    <template slot="nbPeriodes" slot-scope="text, record">
      <div numero="nbPeriodes">
        <a-input-number
          v-if="record.numero === ongoingAlteredRow.numero && ongoingAlteredRow.editable"
          :defaultValue="text"
          :min="1"
          :max="12"
          @change="(nbPeriodes) => handleChangeDetailField(nbPeriodes, record.numero, 'nbPeriodes')" />
        <template v-else><div class="font-size-17">{{ text }}</div></template>
      </div>
    </template>
    <template slot="detail" slot-scope="text, record">
      <div numero="detail" class="inline">
        <a-textarea
          v-if="record.numero === ongoingAlteredRow.numero && ongoingAlteredRow.editable"
          autoFocus
          :autosize="{ minRows: 2, maxRows: 10 }"
          :defaultValue="text"
          placeholder="Rentrez le contenu du détail ici"
          @change="e => handleChangeDetailField(e.target.value, record.numero, 'detail')"
          @keyup.esc="() => handleCancelEditing()" />
        <template v-else>{{ minmizedDetail(text) }}</template>
      </div>
    </template>
    <!-- <span slot="detail" class="ant-table-row-expand-icon ant-table-row-collapsed"></span> -->
    <template slot="actions" slot-scope="text, record">
      <div class='editable-row-operations'>
        <span v-if="record.numero === ongoingAlteredRow.numero && ongoingAlteredRow.editable">
          <a-tooltip placement="top" >
            <template slot="title">
              <span>Sauvegarder les modifications</span>
            </template>
            <a-icon tabindex="0" class="control-icon" type="save" @click="() => handleSaveEditing(record.numero)" @keyup.enter="() => handleSaveEditing(record.numero)"/>
          </a-tooltip>
          <a-popconfirm title='Êtes-vous sûr ?' @confirm="() => handleCancelEditing()" okText="Oui" cancelText="Annuler">
            <a-icon slot="icon" type="question-circle-o" />
            <a-tooltip placement="bottom" >
              <template slot="title">
                <span>Annuler les modifications</span>
              </template>
              <a-icon class="control-icon" type="stop" />
            </a-tooltip>
          </a-popconfirm>
        </span>
        <span v-else>
          <template v-if="user.permissionLevel === 1 || user.permissionLevel === 0 && !record.loginValidateur">
            <a-tooltip placement="top" >
              <template slot="title">
                <span>Modifier le détail</span>
              </template>
              <a-icon class="control-icon" type="edit" @click="() => handleEditDetail(record.numero)" />
            </a-tooltip>
            <a-popconfirm title='Êtes-vous sûr ?' placement="topRight" okText="Oui" cancelText="Annuler" @confirm="() => handleDeleteDetail(record.numero)">
              <a-icon slot="icon" type="question-circle-o" />
              <a-tooltip placement="bottom" >
                <template slot="title">
                  <span>Supprimer le détail</span>
                </template>
                <a-icon class="control-icon" type="close" />
              </a-tooltip>
            </a-popconfirm>
          </template>
          <template v-if="user.permissionLevel === 1">
            <template v-if="record.loginValidateur">
              <a-popconfirm title='Êtes-vous sûr ?' placement="topRight" okText="Oui" cancelText="Annuler" @confirm="() => handleRemoveDetailValidation(record.numero)">
                <a-tooltip placement="bottom" >
                  <template slot="title">
                    <span>Supprimer la validation</span>
                  </template>
                  <a-icon class="control-icon" type="check-circle" />
                </a-tooltip>
              </a-popconfirm>
            </template>
            <template v-else>
              <a-popconfirm placement="topRight" okText="Oui" cancelText="Annuler" @confirm="() => handleValidateDetail(record.numero)">
                <template slot="title">
                    <p>Êtes-vous sûr ?</p>
                </template>
                <a-tooltip placement="bottom" >
                  <template slot="title">
                    <span>Valider le détail</span>
                  </template>
                  <a-icon class="control-icon" type="check" />
                </a-tooltip>
              </a-popconfirm>
            </template>
            <a-tooltip placement="top" >
              <template slot="title">
                <span>Ajouter une remarque</span>
              </template>
              <a-icon class="control-icon" type="warning" @click="() => handleFlagDetail(record.numero)" />
            </a-tooltip>
          </template>
        </span>
      </div>
    </template>
    <p slot="expandedRowRender" slot-scope="record"><pre class="white-space-pre-wrap font-size-17">{{record.detail}}</pre></p>
  </a-table>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import WorkService from '../../services/work_service'
import DateService from '../../services/date_service'
import DetailService from '../../services/detail_service'

const columns = [{
  title: '',
  dataIndex: 'icon',
  width: '5%',
  scopedSlots: { customRender: 'icon' }
}, {
  title: 'Date',
  dataIndex: 'dateDetail',
  width: '11%',
  scopedSlots: { customRender: 'dateDetail' },
  defaultSortOrder: 'descend',
  sorter: (a, b) => moment(a.dateDetail, 'DD.MM.YYYY') - moment(b.dateDetail, 'DD.MM.YYYY')
}, {
  title: 'Période(s)',
  dataIndex: 'nbPeriodes',
  width: '9%',
  scopedSlots: { customRender: 'nbPeriodes' }
}, {
  title: 'Détail',
  dataIndex: 'detail',
  width: '62%',
  scopedSlots: { customRender: 'detail' }
}, {
  title: 'Actions',
  dataIndex: 'actions',
  width: '10%',
  scopedSlots: { customRender: 'actions' }
}]

export default {
  name: 'DetailTable',
  data () {
    return {
      columns,
      dateFormat: 'DD.MM.YYYY'
    }
  },
  methods: {
    moment,
    ...mapActions({
      'setSelectedRow': 'detail/setSelectedRow',
      'setDetailsData': 'detail/setDetailsData',
      'setOngoingAlteredRow': 'detail/setOngoingAlteredRow',
      'setLoading': 'detail/setLoading',
      'addSeenComments': 'work/addSeenComments',
      'removeSeenComment': 'work/removeSeenComment'
    }),
    handleRowClick (record) {
      // Evite de rouvrir / fermer à chaque modification dans les champs textes
      if (!this.ongoingAlteredRow) {
        this.setSelectedRow(record)
      }
    },
    getRowClassName (record) {
      return record === this.selectedRow ? 'selected-row' : ''
    },
    handleEditDetail (numero) {
      console.log('edit')
      // Impossible de modifier 2 lignes à la fois
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      // Si la ligne n'est pas sélectionnée ou est sélectionnée sur un autre travail, on l'a sélectionne
      if (!this.selectedRow || this.selectedRow.numero !== target.numero) {
        this.setSelectedRow(target)
      }
      // nonReactiveCopy est une copie non réactive de target
      const nonReactiveCopy = Object.assign({}, target)
      nonReactiveCopy.editable = true
      this.setOngoingAlteredRow(nonReactiveCopy)
    },
    handleChangeDetailField (value, numero, column) {
      // Gestion des valeurs vides (si le champs date ou périodes est vide)
      if (!value) {
        switch (column) {
          case 'dateDetail':
            value = moment().format(this.dateFormat)
            break
          case 'nbPeriodes':
            value = 1
            break
          case 'detail':
            value = 'Nouveau détail'
        }
      }
      this.ongoingAlteredRow[column] = value
    },
    async handleSaveEditing (numero) {
      console.log('save')
      // Remplacer la ligne numero de data par ongoingAlteredRow
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      if (target) {
        delete this.ongoingAlteredRow.editable
        // préparation des paramètres
        const nonReactiveCopy = Object.assign({}, (({ numero, dateDetail, nbPeriodes, detail }) => ({ numero, dateDetail, nbPeriodes, detail }))(this.ongoingAlteredRow))
        const params = DateService.formatObjectArrayDatesToDisplayFormat([nonReactiveCopy], 'database')[0]
        // api : modifier le détail
        const response = await DetailService.editDetail(params)
        if (response) {
          this.$message.success('Détail modifié')
          Object.assign(target, this.ongoingAlteredRow)
          // Si l'utilisateur authentifié est un élève, la modification entraine la suppression de la validation
          if (this.user.permissionLevel === 0) {
            target.loginValidateur = null
            target.dateValidation = null
            target.heureValidation = null
          }
          this.setOngoingAlteredRow(false)
        }
      }
    },
    handleCancelEditing () {
      console.log('cancel')
      this.setOngoingAlteredRow(false)
    },
    async handleDeleteDetail (numero) {
      console.log('delete')
      // Impossible de supprimer une ligne si une ligne est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      // On ferme la section note de l'enseignant quand la ligne est supprimée
      if (this.selectedRow === target) {
        this.setSelectedRow(false)
      }
      if (target) {
        // api : suppression du travail
        const response = await DetailService.removeDetail(numero)
        if (response) {
          this.$message.success('Détail supprimé')
        }
        // On récupère l'index du tableau à supprimer
        let index = newData.indexOf(target)
        newData.splice(index, 1)
        this.setDetailsData(newData)
      }
    },
    async handleValidateDetail (numero) {
      console.log('validate')
      // Impossible de valider un détail si une ligne est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      if (target) {
        // préparation des paramètres
        let params = Object.assign({}, (({ numero, detail }) => ({ numero, detail }))(target))
        params.loginValidateur = this.user.login
        params.dateValidation = moment().format(this.dateFormat)
        params.heureValidation = moment().format('HH') + 'h' + moment().format('mm')
        const nonReactiveCopy = Object.assign({}, params)
        params = DateService.formatObjectArrayDatesToDisplayFormat([params], 'database')[0]
        // api : modifier le détail
        const response = await DetailService.editDetail(params)
        if (response) {
          this.$message.success('Détail validé')
          Object.assign(target, nonReactiveCopy)
        }
      }
    },
    async handleRemoveDetailValidation (numero) {
      console.log('remove validation')
      // Impossible de deé-valider un détail si une ligne est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      if (target) {
        // préparation des paramètres
        let params = Object.assign({}, (({ numero, detail }) => ({ numero, detail }))(target))
        params.loginValidateur = null
        params.dateValidation = null
        params.heureValidation = null
        const nonReactiveCopy = Object.assign({}, params)
        params = DateService.formatObjectArrayDatesToDisplayFormat([params], 'database')[0]
        // api : modifier le détail
        const response = await DetailService.editDetail(params)
        if (response) {
          this.$message.success('Validation supprimée')
          Object.assign(target, nonReactiveCopy)
        }
      }
    },
    handleFlagDetail (numero) {
      console.log('need remediation')
      // Impossible d'ajouter un commentaire si une ligne est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      const newData = [...this.detailsData]
      const target = newData.filter(item => numero === item.numero)[0]
      // Si la ligne n'est pas sélectionnée ou est sélectionnée sur un autre travail, on l'a sélectionne
      if (!this.selectedRow || this.selectedRow.numero !== target.numero) {
        this.setSelectedRow(target)
      }
      // nonReactiveCopy est une copie non réactive de target
      const nonReactiveCopy = Object.assign({}, target)
      nonReactiveCopy.remediable = true
      nonReactiveCopy.loginCorrecteur = this.user.login
      nonReactiveCopy.dateRemediation = moment().format(this.dateFormat)
      nonReactiveCopy.heureRemediation = moment().format('HH') + 'h' + moment().format('mm')
      this.setOngoingAlteredRow(nonReactiveCopy)
    },
    minmizedDetail (text) {
      if (text.length > 100) {
        return text.toString().substring(0, 100) + '...'
      }
      return text
    },
    isSelectedWorkCommentSeen () {
      // Est-ce que le numero du travail sélectionné existe dans seenComments
      return this.seenComments.includes({ numero: this.selectedWork.numero, remarque: this.selectedWork.remarque })
    },
    showCommentWorkModal () {
      this.$info({
        title: 'Votre travail a fait l\'objet d\'un nouveau commentaire :',
        maskClosable: true,
        width: 700,
        content: (
          <div>
            <pre style="text-align: justify; white-space: pre-wrap; margin-top: 30px;">
              { this.selectedWork.remarque }
            </pre>
          </div>
        )
      })
    }
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme,
      selectedRow: state => state.detail.selectedRow,
      detailsData: state => state.detail.detailsData,
      ongoingAlteredRow: state => state.detail.ongoingAlteredRow,
      user: state => state.auth.user,
      loading: state => state.detail.loading,
      selectedWork: state => state.work.selectedWork,
      seenComments: state => state.work.seenComments
    })
  },
  async created () {
    // Mise à jour de la remarque du travail à l'ouverture de celui-ci
    this.setLoading(true)
    // Si l'utilisateur authentifié est un élève
    if (this.user.permissionLevel === 0) {
      const responseComment = await WorkService.getWork(this.selectedWork.numero)
      if (responseComment) {
        const comment = responseComment.data.data[0].remarque
        // Récupération de la ligne dans seenComments
        const newData = [...this.seenComments]
        const target = newData.filter(item => this.selectedWork.numero === item.numero)[0]
        // Une remarque existe pour ce travail
        if (comment) {
          // Si la remarque n'avait pas encore été vue ou elle a été modifiée, on l'ajoute dans la liste des remarques vues
          if (!target || target.remarque !== comment) {
            Object.assign(this.selectedWork, { remarque: comment })
            // Toggle la modale du commentaire
            this.showCommentWorkModal()
            // Réécrire avec la nouvelle remarque
            let index = this.seenComments.indexOf(target)
            if (index > -1) {
              this.removeSeenComment(index)
            }
            this.addSeenComments({ numero: this.selectedWork.numero, remarque: this.selectedWork.remarque })
          }
        // Un commentaire précédemment appliqué a été supprimé
        } else if (target) {
          // On supprime la ligne dans seenComments
          let index = this.seenComments.indexOf(target)
          if (index > -1) {
            this.removeSeenComment(index)
          }
        }
      }
    }
    // Récupération des détails
    const responseDetails = await WorkService.getDetails(this.$route.params.numero)
    if (responseDetails) {
      const data = DateService.formatObjectArrayDatesToDisplayFormat(responseDetails.data.data, 'display')
      // Si le travail contient des détails
      if (Array.isArray(data) && data.length) {
        this.setDetailsData(data)
        // Est-ce que l'URL comporte un tag ?
        if (this.$route.hash) {
          let hash = Number(this.$route.hash.substr(1))
          const newData = [...this.detailsData]
          const target = newData.filter(item => hash === item.numero)[0]
          if (target) {
            this.setSelectedRow(target)
          }
        }
      }
      this.setLoading(false)
    }
  }
}
</script>
<style scoped lang="scss">
.editable-row-operations a {
  margin-right: 8px;
}
.ant-input{
  width: 95%;
}
</style>
